import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CloseIcon from '@material-ui/icons/Close';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { MEDIA_TYPE, normalizeMediaType, openInNewTab } from '../../utils/openMedia';
import { resolveVideoSource } from '../../utils/videoSource';

// Proporção 16:9 responsiva: altura derivada da largura via padding-top.
const ratioBox = { position: 'relative', width: '100%', paddingTop: '56.25%', backgroundColor: '#000' };
const fillRatioBox = { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 };

const PlaybackError = () => (
    <Typography color="error" align="center" style={{ padding: 24 }}>
        Não foi possível reproduzir este vídeo aqui. Tente abrir em uma nova aba.
    </Typography>
);

const VideoContent = ({ media }) => {
    const [hasError, setHasError] = useState(false);
    const source = resolveVideoSource(media.link);

    if (hasError) return <PlaybackError />;

    return (
        <div style={ratioBox}>
            {
                source.kind === 'file'
                    ? <video src={source.url} controls autoPlay playsInline onError={() => setHasError(true)} style={fillRatioBox} />
                    : (
                        <iframe
                            src={source.url}
                            title={media.name}
                            allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
                            allowFullScreen
                            style={fillRatioBox}
                        />
                    )
            }
        </div>
    );
};

const MediaContent = ({ media }) => {
    if (normalizeMediaType(media.type) === MEDIA_TYPE.AUDIO)
        return <audio src={media.link} controls autoPlay style={{ width: '100%' }} />;

    return <VideoContent media={media} />;
};

/**
 * Player de vídeo/áudio. `media` nulo = fechado.
 * Ocupa a tela inteira em telas pequenas; nas demais, largura fluida até `md`.
 */
const MediaPlayerDialog = ({ media, onClose }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <Dialog open={Boolean(media)} onClose={onClose} fullScreen={isSmallScreen} fullWidth maxWidth="md">
            {media && (
                <>
                    <DialogTitle disableTypography style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="h6" noWrap style={{ flex: 1, minWidth: 0 }}>{media.name}</Typography>
                        <IconButton edge="end" aria-label="Fechar" onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        {/* key: nova mídia = novo estado de erro. */}
                        <MediaContent key={media.id} media={media} />
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={() => openInNewTab(media.link)}>
                            <OpenInNewIcon fontSize="small" style={{ marginRight: 8 }} />
                            Abrir em nova aba
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
};

export default MediaPlayerDialog;
